import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';

const McpToolsText = observer((props) => {
  const {
    className = '',
    children,
    event,
  } = props;

  return (
    <div className={`${className}`} data-id={event?.planStepId}>
      <div className="text-14px leading-22px text-black text-opacity-60 break-all">
        {children}
      </div>
    </div>
  )
});
export default McpToolsText;